import { h, FunctionalComponent } from "preact";

const RequiredSymbol: FunctionalComponent = () => {
    return <span style={{ marginRight: 1, color: "red" }}>*</span>;
};

export default RequiredSymbol;
